export function siteModal(config, Alpine) {
  return {
    show: config.show || false,
    name: config.name || "",

    init() {},

    openModal(data) {
      this.show = data;
    }
  };
}
